<template>
	<section id="user">
		<NoticationBell @openDevLogsModal="devLogsModal = true" />
		<HelpMenu />
		<div class="profile" @click="toggleMenu">
			<div class="profile-container">
				<avatar :href="user_image"></avatar>
				<div id="login-back-icon" @click.stop="handleLoginBack" v-if="loggedAs">
					<recover_icon circleColor="var(--violet-300)" pathColor="var(--violet-600)"
						circleHoverColor="var(--violet-400)" pathHoverColor="var(--violet-700)" />
				</div>
			</div>
			<p class="name">{{ user_name }} <i :class="['dropdown-icon', menuOpen ? 'icon-up' : 'icon-down']"></i></p>
			<ul v-if="menuOpen" class="dropdown-menu">
				<li>
					<router-link to="/edit-profile">{{ t('edit_profile') }}</router-link>
				</li>
				<featureSection :feature-name="'plan management'" :show="false" style="margin: 0;">
					<li>
						<router-link to="/billing">{{ t('plan_management.title') }}</router-link>
					</li>
				</featureSection>
				<li v-if="user.hasAccess('super_admin') == true">
					<router-link to="/global-settings">{{ t('app_settings') }}</router-link>
				</li>
				<li>
					<div @click="devLogsModal = true">{{ t('app_updates') }}</div>
				</li>
				<li>
					<div @click="handleLogout" id="menu_logout_click">{{ t('logout') }}</div>
				</li>
			</ul>
		</div>
		<!--* <select v-model="locale" @change="onLocaleChange">*
*            <option value="en">En</option>*
*            <option value="fr">Fr</option>*
*        </select> *-->
		<DevsLogsModal :open="devLogsModal" @updateModal="devLogsModal = !devLogsModal" />
	</section>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import NoticationBell from '../profile/NotificationBell.vue';
import { useAuthStore } from '@/store/global/auth';
import { useProfileStore } from '@/store/global/profile.js';
import avatar from './avatar.vue';
import { storeToRefs } from 'pinia';
import HelpMenu from '@/components/utilities/profile/HelpMenu.vue';
import DevsLogsModal from '@/components/utilities/modal/DevsLogsModal.vue';
import featureSection from '@/components/utilities/featureSection.vue';
import recover_icon from '@/components/utilities/icons/svg/recover_icon.vue';
import { useAdminStore } from '@/store/global_settings/admin';
const adminStore = useAdminStore();
const { loggedAs } = storeToRefs(adminStore);

const user = useAuthStore();
const profile = useProfileStore();
const { user_name, user_image, activity_data } = storeToRefs(profile);

import { useI18n } from 'vue-i18n';

const { t, locale, availableLocales } = useI18n({});
const devLogsModal = ref(false);
const router = useRouter();

await profile.fetchData();
let menuOpen = ref(false);

onMounted(() => {
	document.addEventListener('click', closeMenu);
});

async function toggleMenu() {
	menuOpen.value = !menuOpen.value;
}

function closeMenu(event) {
	if (!event.target.closest('.profile')) {
		menuOpen.value = false;
	}
}

const handleLogout = () => {
	const persistentSettings = {
		show_deleted_tasks: user.super_admin.show_deleted_tasks,
		show_market_id: user.super_admin.show_market_id,
		language: localStorage.getItem('language'),
		locale: localStorage.getItem('locale'),
		selectedProject: localStorage.getItem('persistent_selectedProject'),
		selectedMarket: localStorage.getItem('persistent_selectedMarket')
	};

	localStorage.clear();

	if (persistentSettings.show_deleted_tasks !== undefined) {
		localStorage.setItem('persistent_show_deleted_tasks', persistentSettings.show_deleted_tasks.toString());
	}
	if (persistentSettings.show_market_id !== undefined) {
		localStorage.setItem('persistent_show_market_id', persistentSettings.show_market_id.toString());
	}
	if (persistentSettings.language) {
		localStorage.setItem('language', persistentSettings.language);
	}
	if (persistentSettings.locale) {
		localStorage.setItem('locale', persistentSettings.locale);
	}
	if (persistentSettings.selectedProject) {
		localStorage.setItem('persistent_selectedProject', persistentSettings.selectedProject);
	}
	if (persistentSettings.selectedMarket) {
		localStorage.setItem('persistent_selectedMarket', persistentSettings.selectedMarket);
	}

	user.logout();

	router.push('/logout');
};

const handleLoginBack = async () => {
	await adminStore.ConnectBack();
};
</script>

<style lang="scss" scoped>
#user {
	display: flex;
	align-items: center;

	.plans-icon {
		cursor: pointer;
		width: 34px;
		height: 34px;
	}

	.plans-icon2 {
		cursor: pointer;
		width: 44px;
		height: 44px;
	}

	.profile {
		position: relative;
		display: flex;
		align-items: center;
		cursor: pointer;

		.profile-container {
			position: relative;
		}

		.name {
			font-weight: 600;
			margin-right: 0.5rem;
			position: relative;
			display: inline-block;
		}

		.dropdown-menu {
			position: absolute;
			top: 2.5rem;
			left: 0;
			width: 100%;
			list-style: none;
			padding: 0;
			margin: 0;
			background-color: var(--blanc);
			border: 1px solid var(--gris-100);
			border-radius: 8px;
			z-index: 999;

			li {
				padding: 5px 1rem;

				&:first-child {
					border-radius: 9px 9px 0 0;
				}

				&:last-child {
					border-radius: 0 0 9px 9px;
				}

				&:hover {
					background-color: var(--bleu-100);
					border-radius: 0px;
				}

				a {
					width: 100%;
					list-style: none;
					display: block;
					text-decoration: none;
				}
			}
		}
	}
}

#login-back-icon {
	cursor: pointer;
	width: 34px;
	height: 34px;
	position: absolute;
	right: -5px;
	bottom: -15px;
	z-index: 9;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>